module.exports = __webpack_public_path__ + "assets/hand-pointing.3a27dcf3.svg";